import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppShell from "@/components/AppShell";

import Setup from "@/pages/Setup";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Firms from "@/pages/Firms";
import FirmDetail from "@/pages/FirmDetail";
import OrgSettings from "@/pages/OrgSettings";
import UsersPage from "@/pages/UsersPage";
import TemplatesPage from "@/pages/TemplatesPage";
import CatalogPage from "@/pages/CatalogPage";
import PersonnelNotifications from "@/pages/PersonnelNotifications";
import OutgoingEmails from "@/pages/OutgoingEmails";
import CustomerFolders from "@/pages/CustomerFolders";
import CustomerVisits from "@/pages/CustomerVisits";
import CustomerTraining from "@/pages/CustomerTraining";
import CustomerDrivers from "@/pages/CustomerDrivers";
import YearManagement from "@/pages/YearManagement";
import BackupPage from "@/pages/BackupPage";

function Shell({ children, roles }) {
  return (
    <ProtectedRoute roles={roles}>
      <AppShell>{children}</AppShell>
    </ProtectedRoute>
  );
}

function AppRoutes() {
  const { refreshUser } = useAuth();
  useEffect(() => { refreshUser(); }, []); // eslint-disable-line
  return (
    <Routes>
      <Route path="/kurulum" element={<Setup />} />
      <Route path="/giris" element={<Login />} />
      <Route path="/sifremi-unuttum" element={<ForgotPassword />} />
      <Route path="/sifre-belirle" element={<ResetPassword />} />
      <Route path="/" element={<Shell><Dashboard /></Shell>} />
      <Route path="/firmalar" element={<Shell roles={["main_admin", "org_manager", "advisor"]}><Firms /></Shell>} />
      <Route path="/firmalar/:id" element={<Shell roles={["main_admin", "org_manager", "advisor"]}><FirmDetail /></Shell>} />
      <Route path="/kullanicilar" element={<Shell roles={["main_admin", "org_manager"]}><UsersPage /></Shell>} />
      <Route path="/sablonlar" element={<Shell roles={["main_admin", "org_manager"]}><TemplatesPage /></Shell>} />
      <Route path="/katalog" element={<Shell roles={["main_admin"]}><CatalogPage /></Shell>} />
      <Route path="/personel-bildirimleri" element={<Shell><PersonnelNotifications /></Shell>} />
      <Route path="/belgelerim" element={<Shell roles={["customer"]}><CustomerFolders /></Shell>} />
      <Route path="/ziyaret-raporlarim" element={<Shell roles={["customer"]}><CustomerVisits /></Shell>} />
      <Route path="/egitim-tatbikatlar" element={<Shell roles={["customer"]}><CustomerTraining /></Shell>} />
      <Route path="/surucu-arac" element={<Shell roles={["customer"]}><CustomerDrivers /></Shell>} />
      <Route path="/kurulus-ayarlari" element={<Shell roles={["main_admin", "org_manager"]}><OrgSettings /></Shell>} />
      <Route path="/yil-yonetimi" element={<Shell roles={["main_admin", "org_manager", "advisor"]}><YearManagement /></Shell>} />
      <Route path="/yedekleme" element={<Shell roles={["main_admin"]}><BackupPage /></Shell>} />
      <Route path="/giden-epostalar" element={<Shell roles={["main_admin", "org_manager"]}><OutgoingEmails /></Shell>} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
